export const arrowButtonVariants = (theme: any) => ({
  "full-width": {
    width: "60px",
    height: "60px",
    backgroundColor: "rgba(7, 11, 22, 0.7)",
    "&.slick-next": {
      right: "18px",
    },
    animation: "fade-in 0.3s ease-in",

    "@keyframes fade-in": {
      "0%": {
        opacity: 0,
      },

      "100%": {
        opacity: 4,
      },
    },
  },
  dots: {
    width: "fit-content",
    height: "fit-content",
    backgroundColor: "transparent",
    opacity: 1,
    "&.slick-next": {
      right: "0",
    },
    animation: "fade-in-light 0.3s ease-in",

    "@keyframes fade-in-light": {
      "0%": {
        opacity: 0,
      },

      "100%": {
        opacity: 1,
      },
    },
  },
});

export const sliderVariants = (theme: any) => ({
  "full-width": {
    ".slick-list": {
      overflow: "visible",
    },
  },
  dots: {
    paddingRight: 10,
    paddingLeft: 10,
    ".slick-list": {
      overflow: "hidden",
    },
    ".slick-dots": {
      listStyleType: "none",
      margin: 0,
      padding: 0,
      display: "flex !important",
      justifyContent: "center",
      opacity: "0.5 !important",
      li: {
        marginRight: "10px",
        padding: 0,
      },
      "li:last-of-type": {
        margin: 0,
      },
      button: {
        lineHeight: 0,
        fontSize: 0,
        display: "block",
        color: "transparent",
        border: 0,
        outline: "none",
        backgroundColor: "grey-blue",
        borderRadius: "50%",
        width: "9px",
        height: "9px",
        padding: 0,
        opacity: "0.2 !important",
        transition: "opacity 0.3s ease-in-out",
        ":hover": {
          opacity: "1 !important",
        },
      },
      "li.slick-active": {
        button: {
          backgroundColor: "grey-blue",
          opacity: "1 !important",
        },
      },
    },
  },
});
